import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const Spinner = ({ size = '', color = 'gray', fontSize = 100 }) => {
  return (
    <div>
      <Spin
        indicator={
          <LoadingOutlined
            style={{
              fontSize,
              color,
            }}
            spin
          />
        }
        size={size}
      />
    </div>
  );
};
export default Spinner;
